import store from "@/common/store";
import { UserInfo } from "@/user/class";
import * as routerUtil from "@/common/utils/routerUtil";
import * as api from "@/common/api";

/**
 * 로그인 성공시 후처리
 * @param userInfo
 */
export const loginSuccess = (userInfo: UserInfo, moveNext = false) => {
  setUserInfoStore(userInfo);

  console.log("====== loginSuccess ======");
  const encoded = routerUtil.getNextRoute();
  console.log("encoded : ", encoded);
  if (moveNext && encoded && typeof encoded === "string") {
    try {
      const decoded = JSON.parse(decodeURIComponent(encoded));
      console.log("decoded : ", decoded);
      // 외부 서비스(blog.breezer.co.kr 등)에서 넘어온 경우 절대 URL로 복귀
      if (typeof decoded.path === "string" && decoded.path.startsWith("http")) {
        window.location.href = decoded.path;
        return;
      }
      const nextRoute = encodeURIComponent(
        JSON.stringify({ query: decoded.query })
      );
      routerUtil.moveTo(decoded.path, nextRoute);
      // router.push({
      //   path: decoded.path,
      //   query: decoded.query,
      // });
    } catch (e) {
      console.error("⚠️ nextRoute decode error", e);
      // router.push("/");
      routerUtil.moveTo("/");
    }
  } else {
    routerUtil.moveTo("/");
  }
};

/**
 * 이미 살아 있는 서버 세션을 화면 상태에만 반영한다 (이동 없음).
 *
 * <p>새로고침하면 Vuex 는 비지만 서버 세션 쿠키는 남아 있다. 그때 쓰는 함수다.
 * {@link loginSuccess} 와 달리 <b>절대 화면을 옮기지 않는다</b> —
 * 옮기면 주소를 직접 치거나 새로고침할 때마다 홈으로 튕긴다.
 */
export const restoreLoginState = (userInfo: UserInfo) => {
  setUserInfoStore(userInfo);
};

/**
 * 로그인필요한 기능요청시 로그인 체크
 * @returns
 */
export const loginCheckAlert = () => {
  if (!isLogin()) {
    alert("로그인 후 이용가능합니다.");
    return false;
  }
};

/**
 * 로그인 여부 조회
 * @returns
 */
export const isLogin = () => {
  const userInfo = getLoginInfo();
  return userInfo.id != null && userInfo.id != "";
};

/**
 * 세션 체크
 * @param silent true면 세션 만료 시 알럿 없이 조용히 로그아웃
 */
export const sessionCheck = async (silent = false) => {
  console.log("[sessionCheck] silent:", silent);

  // api 요청해
  // 웹이 로그인인데 서버도 로그인이야? 무시
  // 웹이 로그인인데 서버는 로그아웃이야? 세션만료
  // 웹이 로그아웃인데 서버는 로그인이야? 로그인처리 화면그대로
  // 웹이 로그아웃인데 서버도 로그아웃이야? 무시

  const res = await api.user().sessionCheck();

  // 서버 미응답(네트워크 에러) 시 웹 로그인 상태만으로 판단
  if (res && res.status === 500 && res.data?.message?.includes("Network error")) {
    console.warn("[sessionCheck] 서버 연결 불가 - 현재 웹 로그인 상태 유지");
    return isLogin();
  }

  const serverLogin = res.status !== 401 && res.status !== 403;
  const webLogin = isLogin();
  console.log("serverLogin : ", serverLogin);
  console.log("webLogin : ", webLogin);
  if (serverLogin && webLogin) {
    // 서버 로그인 && 웹로그인
    // Do nothing
    return true;
  } else if (serverLogin && !webLogin) {
    console.log("세션정상");
    // 서버 로그인 && 웹 미로그인 → 화면 상태만 복원한다.
    //
    // 🚨 여기서 loginSuccess() 를 부르면 안 된다.
    // loginSuccess 는 "방금 로그인 버튼을 눌렀다"는 상황용이라 끝에 moveTo("/") 로 홈으로 보낸다.
    // 그런데 이 분기는 **새로고침·주소 직접 입력** 때마다 탄다(Vuex 는 새로고침이면 비어 있으니까).
    // 그 결과 breezer.co.kr/keyword/search 로 들어가면 세션을 복원하면서 홈으로 튕겼다.
    // 로또·부동산·옷장 등 **모든 서비스의 모든 주소**가 같은 증상이었다.
    // 세션 복원은 상태만 채우고 화면은 건드리지 않는다.
    const userInfo = new UserInfo();
    userInfo.setUserInfoByResponse(res);
    restoreLoginState(userInfo);
    return true;
  } else if (!serverLogin && webLogin) {
    console.log("세션만료");
    // 서버 미로그인 && 웹로그인
    // 세션만료 로그아웃처리
    if (!silent) {
      alert("세션이 만료되어 로그아웃되었습니다.");
    }
    silentLogout();
    return false;
  } else {
    // 서버 미로그인 && 웹 미로그인
    // 그대로
    return false;
  }
};

/**
 * 조용히 로그아웃 (알럿 없음, 리다이렉트 없음)
 */
export const silentLogout = () => {
  store.commit("logout");
};

export const logout = () => {
  //
  store.commit("logout");
  routerUtil.logoutAndRedirectHome();
};

export const logoutSuccess = () => {
  // 로그아웃이 성공하면 store 에서 지우고
  store.commit("logout");
  // 현재 페이지가 인증이 필요한 페이지면 홈으로 가야해
  routerUtil.logoutAndRedirectHome();
};

/**
 * Store
 */

const setUserInfoStore = (userInfo: UserInfo) => {
  store.commit("setLoginInfo", userInfo);
};

/**
 * 저장된 로그인정보 조회
 * @returns 로그인정보
 */
export const getLoginInfo = () => {
  //
  return store.getters.getUserInfo;
};
